import FigmaBadge from '../Elements/FigmaBadge';
import urlHelper from '../Helpers/urlHelper';
import React from 'react';
import moneyHelper from '../Helpers/moneyHelper';
import mathHelper from '../Helpers/mathHelper';

export default class VPricingDetailListTotalItem {
  constructor(item) {
    if (item === undefined) {
      this.PricingDetailId = '';
      this.PricingId = '';
      this.IsCurrentVersion = '';
      this.OverrideFee = '';
      this.PricingFeeBase = '';
      this.CountryName = '';
      this.StatusCode = '';
      this.Status = '';
      this.Version = '';
      this.Name = '';
      this.ServiceId = '';
      this.ServiceName = '';
      this.FieldworkCycleCode = '';
      this.ServiceTypeCode = '';
      this.FieldworkCycle = '';
      this.VideoCaseType = '';
      this.OfficeId = '';
      this.OfficeName = '';
      this.OpportunityOfficeId = '';
      this.OpportunityOfficeName = '';
      this.IsOwningOffice = '';
      this.EvalBonusPerCycle = '';
      this.BankChargesPerCycle = '';
      this.AnnualRecruitingCost = '';
      this.CurrencySymbol = '';
      this.CurrencyCode = '';
      this.CurrencyRate = '';
      this.FinalizedInverseRate = '';
      this.CostFromEditOffice = '';
      this.AnnualTestcastorCost = '';
      this.VocazillaAvgCallLengthMinutes = '';
      this.IvrfeePerEval = '';
      this.AnnualCallsToShopperCost = '';
      this.LengthVideoShopHours = '';
      this.IsVideoCdr = '';
      this.IsVideoDvd = '';
      this.VideoCaseTypeCode = '';
      this.MailingCostPerEval = '';
      this.EditorCostPerEval = '';
      this.TransCostPerEval = '';
      this.ExtDataCheckPerEval = '';
      this.NumCyclesPerYr = '';
      this.OwningOfficeIsEditing = '';
      this.OwningOfficeIsTranslating = '';
      this.OwningOfficeIsChecking = '';
      this.CommissionPct = '';
      this.OverheadRatePct = '';
      this.PayrollTaxPct = '';
      this.TeamLeadDailyCost = '';
      this.ProjMgrDailyCost = '';
      this.OperationsMgrDailyCost = '';
      this.AssistantProjMgrDailyCost = '';
      this.PanelMgrRecruiterDailyCost = '';
      this.EditDataCheckDailyCost = '';
      this.EmpBenefitsDailyCost = '';
      this.EmpBenefitsDailyCostOffice = '';
      this.SMCostPerEval = '';
      this.VocazillaCostPerEval = '';
      this.IvrfeeCostPerEval = '';
      this.IcrfeeCostPerEval = '';
      this.EditorCostPerHour = '';
      this.TimeCaptureCostPerHour = '';
      this.ShippingCostPerEval = '';
      this.CardCostPerEval = '';
      this.StreamingCostPerHour = '';
      this.CdrcostPerEval = '';
      this.DvdcostPerEval = '';
      this.CaseCostPerEval = '';
      this.CaseCostPerEval1 = '';
      this.CaseCostPerEval2 = '';
      this.Dnepct = '';
      this.TeamLeadDailyCostOffice = '';
      this.ProjMgrDailyCostOffice = '';
      this.OperationsMgrDailyCostOffice = '';
      this.AssistantProjMgrDailyCostOffice = '';
      this.PanelMgrRecruiterDailyCostOffice = '';
      this.EditDataCheckDailyCostOffice = '';
      this.TeamLeadDaysPerCycle = '';
      this.ProjMgrDaysPerCycle = '';
      this.OperationsMgrDaysPerCycle = '';
      this.AssistantProjMgrDaysPerCycle = '';
      this.PanelMgrRecruiterDaysPerCycle = '';
      this.EditDataCheckDaysPerCycle = '';
      this.TeamLeadDailyCostOverride = '';
      this.ProjMgrDailyCostOverride = '';
      this.OperationsMgrDailyCostOverride = '';
      this.AssistantProjMgrDailyCostOverride = '';
      this.PanelMgrRecruiterDailyCostOverride = '';
      this.EditDataCheckDailyCostOverride = '';
      this.EmpBenefitsDailyCostOverride = '';
      this.CreatedOn = '';
      this.CreatedBy = '';
      this.CreatedByName = '';
      this.ModifiedOn = '';
      this.ModifiedBy = '';
      this.ModifiedByName = '';
      this.FinalizedOn = '';
      this.FinalizedRate = '';
      this.FinalizedOfficeInverseRate = '';
      this.FinalizedOpportunityInverseRate = '';
      this.OpportunityCurrencyCode = '';
      this.OpportunityCurrencySymbol = '';
      this.OpportunityCurrencyRate = '';
      this.OpportunityCurrencyInverseRate = '';
      this.FieldWorkNotes = '';
      this.ClientRevenueNotes = '';
      this.MarkUpNotes = '';
      this.EvaluatorFeeNotes = '';
      this.ShopperTravelCostNotes = '';
      this.EvaluatorRecruitingCostNotes = '';
      this.EditingCostNotes = '';
      this.EmployeeCostNotes = '';
      this.VideoCostsNotes = '';
      this.MiscCostText1 = '';
      this.MiscCostText2 = '';
      this.MiscCostText3 = '';
      this.MiscCostPerCycleText1 = '';
      this.MiscCostPerCycleText2 = '';
      this.MiscCostPerCycleText3 = '';
      this.AnnualMiscCost3 = '';
      this.MiscCostPerCycle1 = '';
      this.MiscCostPerCycle2 = '';
      this.MiscCostPerCycle3 = '';
      this.NumEvalsTotal = '';
      this.ClientRevenueTotal = '';
      this.ClientRevenueBase = '';
      this.EvalCostTotal = '';
      this.TravelCostTotal = '';
      this.RecruitingCostTotal = '';
      this.EditingCostTotal = '';
      this.EmployeeCostTotal = '';
      this.DeferredCostTotal = '';
      this.OtherCostTotal = '';
      this.VideoCostTotal = '';
      this.FieldWorkCostTotal = '';
      this.CostTotal = '';
      this.OwningOfficeCostTotal = '';
      this.ClientFeeBase = '';
      this.ClientFeeTotal = '';
      this.RevenuePct = '';
      this.Selected = false;
      this.OperationsMgrDailyCostOfficeOverrideCur = 0;
      return;
    }
    this.PricingDetailId = item.pricingDetailId;
    this.PricingId = item.pricingId;
    this.IsCurrentVersion = item.isCurrentVersion;
    this.OverrideFee = item.overrideFee;
    this.PricingFeeBase = item.pricingFeeBase;
    this.CountryName = item.countryName;
    this.StatusCode = item.statusCode;
    this.Status = item.status;
    this.Version = item.version;
    this.Name = item.name;
    this.ServiceId = item.serviceId;
    this.ServiceName = item.serviceName;
    this.FieldworkCycleCode = item.fieldworkCycleCode;
    this.ServiceTypeCode = item.serviceTypeCode;
    this.FieldworkCycle = item.fieldworkCycle;
    this.VideoCaseType = item.videoCaseType;
    this.OfficeId = item.officeId;
    this.OfficeName = item.officeName;
    this.OpportunityOfficeId = item.opportunityOfficeId;
    this.OpportunityOfficeName = item.opportunityOfficeName;
    this.IsOwningOffice = item.isOwningOffice;
    this.EvalBonusPerCycle = item.evalBonusPerCycle;
    this.BankChargesPerCycle = item.bankChargesPerCycle;
    this.AnnualRecruitingCost = item.annualRecruitingCost;
    this.CurrencySymbol = item.currencySymbol;
    this.CurrencyCode = item.currencyCode;
    this.CurrencyRate = item.currencyRate;
    this.FinalizedInverseRate = item.finalizedInverseRate;
    this.CostFromEditOffice = item.costFromEditOffice;
    this.AnnualTestcastorCost = item.annualTestcastorCost;
    this.VocazillaAvgCallLengthMinutes = item.vocazillaAvgCallLengthMinutes;
    this.IvrfeePerEval = item.ivrfeePerEval;
    this.AnnualCallsToShopperCost = item.annualCallsToShopperCost;
    this.LengthVideoShopHours = item.lengthVideoShopHours;
    this.IsVideoCdr = item.isVideoCdr;
    this.IsVideoDvd = item.isVideoDvd;
    this.VideoCaseTypeCode = item.videoCaseTypeCode;
    this.MailingCostPerEval = item.mailingCostPerEval;
    this.EditorCostPerEval = item.editorCostPerEval;
    this.TransCostPerEval = item.transCostPerEval;
    this.ExtDataCheckPerEval = item.extDataCheckPerEval;
    this.NumCyclesPerYr = item.numCyclesPerYr;
    this.OwningOfficeIsEditing = item.owningOfficeIsEditing;
    this.OwningOfficeIsTranslating = item.owningOfficeIsTranslating;
    this.OwningOfficeIsChecking = item.owningOfficeIsChecking;
    this.CommissionPct = item.commissionPct;
    this.OverheadRatePct = item.overheadRatePct;
    this.PayrollTaxPct = item.payrollTaxPct;
    this.TeamLeadDailyCost = item.teamLeadDailyCost;
    this.ProjMgrDailyCost = item.projMgrDailyCost;
    this.OperationsMgrDailyCost = item.operationsMgrDailyCost;
    this.AssistantProjMgrDailyCost = item.assistantProjMgrDailyCost;
    this.PanelMgrRecruiterDailyCost = item.panelMgrRecruiterDailyCost;
    this.EditDataCheckDailyCost = item.editDataCheckDailyCost;
    this.EmpBenefitsDailyCost = item.empBenefitsDailyCost;
    this.EmpBenefitsDailyCostOffice = item.empBenefitsDailyCostOffice;
    this.SMCostPerEval = item.smcostPerEval;
    this.VocazillaCostPerEval = item.vocazillaCostPerEval;
    this.IvrfeeCostPerEval = item.ivrfeeCostPerEval;
    this.IcrfeeCostPerEval = item.icrfeeCostPerEval;
    this.EditorCostPerHour = item.editorCostPerHour;
    this.TimeCaptureCostPerHour = item.timeCaptureCostPerHour;
    this.ShippingCostPerEval = item.shippingCostPerEval;
    this.CardCostPerEval = item.cardCostPerEval;
    this.StreamingCostPerHour = item.streamingCostPerHour;
    this.CdrcostPerEval = item.cdrcostPerEval;
    this.DvdcostPerEval = item.dvdcostPerEval;
    this.CaseCostPerEval = item.caseCostPerEval;
    this.CaseCostPerEval1 = item.caseCostPerEval1;
    this.CaseCostPerEval2 = item.caseCostPerEval2;
    this.Dnepct = item.dnepct;
    this.TeamLeadDailyCostOffice = item.teamLeadDailyCostOffice;
    this.ProjMgrDailyCostOffice = item.projMgrDailyCostOffice;
    this.OperationsMgrDailyCostOffice = item.operationsMgrDailyCostOffice;
    this.AssistantProjMgrDailyCostOffice = item.assistantProjMgrDailyCostOffice;
    this.PanelMgrRecruiterDailyCostOffice = item.panelMgrRecruiterDailyCostOffice;
    this.EditDataCheckDailyCostOffice = item.editDataCheckDailyCostOffice;
    this.TeamLeadDaysPerCycle = item.teamLeadDaysPerCycle;
    this.ProjMgrDaysPerCycle = item.projMgrDaysPerCycle;
    this.OperationsMgrDaysPerCycle = item.operationsMgrDaysPerCycle;
    this.AssistantProjMgrDaysPerCycle = item.assistantProjMgrDaysPerCycle;
    this.PanelMgrRecruiterDaysPerCycle = item.panelMgrRecruiterDaysPerCycle;
    this.EditDataCheckDaysPerCycle = item.editDataCheckDaysPerCycle;
    this.TeamLeadDailyCostOverride = item.teamLeadDailyCostOverride;
    this.ProjMgrDailyCostOverride = item.projMgrDailyCostOverride;
    this.OperationsMgrDailyCostOverride = item.operationsMgrDailyCostOverride;
    this.AssistantProjMgrDailyCostOverride = item.assistantProjMgrDailyCostOverride;
    this.PanelMgrRecruiterDailyCostOverride = item.panelMgrRecruiterDailyCostOverride;
    this.EditDataCheckDailyCostOverride = item.editDataCheckDailyCostOverride;
    this.EmpBenefitsDailyCostOverride = item.empBenefitsDailyCostOverride;
    this.CreatedOn = item.createdOn;
    this.CreatedBy = item.createdBy;
    this.CreatedByName = item.createdByName;
    this.ModifiedOn = item.modifiedOn;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedByName = item.modifiedByName;
    this.FinalizedOn = item.finalizedOn;
    this.FinalizedRate = item.finalizedRate;
    this.FinalizedOfficeInverseRate = item.finalizedOfficeInverseRate;
    this.FinalizedOpportunityInverseRate = item.finalizedOpportunityInverseRate;
    this.OpportunityCurrencyCode = item.opportunityCurrencyCode;
    this.OpportunityCurrencySymbol = item.opportunityCurrencySymbol;
    this.OpportunityCurrencyRate = item.opportunityCurrencyRate;
    this.OpportunityCurrencyInverseRate = item.opportunityCurrencyInverseRate;
    this.FieldWorkNotes = item.fieldWorkNotes;
    this.ClientRevenueNotes = item.clientRevenueNotes;
    this.MarkUpNotes = item.markUpNotes;
    this.EvaluatorFeeNotes = item.evaluatorFeeNotes;
    this.ShopperTravelCostNotes = item.shopperTravelCostNotes;
    this.EvaluatorRecruitingCostNotes = item.evaluatorRecruitingCostNotes;
    this.EditingCostNotes = item.editingCostNotes;
    this.EmployeeCostNotes = item.employeeCostNotes;
    this.VideoCostsNotes = item.videoCostsNotes;
    this.MiscCostText1 = item.miscCostText1;
    this.MiscCostText2 = item.miscCostText2;
    this.MiscCostText3 = item.miscCostText3;
    this.MiscCostPerCycleText1 = item.miscCostPerCycleText1;
    this.MiscCostPerCycleText2 = item.miscCostPerCycleText2;
    this.MiscCostPerCycleText3 = item.miscCostPerCycleText3;
    this.AnnualMiscCost3 = item.annualMiscCost3;
    this.MiscCostPerCycle1 = item.miscCostPerCycle1;
    this.MiscCostPerCycle2 = item.miscCostPerCycle2;
    this.MiscCostPerCycle3 = item.miscCostPerCycle3;
    this.NumEvalsTotal = item.numEvalsTotal;
    this.ClientRevenueTotal = item.clientRevenueTotal;
    this.ClientRevenueBase = item.clientRevenueBase;
    this.EvalCostTotal = item.evalCostTotal;
    this.TravelCostTotal = item.travelCostTotal;
    this.RecruitingCostTotal = item.recruitingCostTotal;
    this.EditingCostTotal = item.editingCostTotal;
    this.EmployeeCostTotal = item.employeeCostTotal;
    this.DeferredCostTotal = item.deferredCostTotal;
    this.OtherCostTotal = item.otherCostTotal;
    this.VideoCostTotal = item.videoCostTotal;
    this.FieldWorkCostTotal = item.fieldWorkCostTotal;
    this.FieldWorkRevenueTotal = item.fieldWorkRevenueTotal;
    this.CostTotal = item.costTotal;
    this.OwningOfficeCostTotal = item.owningOfficeCostTotal;
    this.ClientFeeBase = item.clientFeeBase;
    this.ClientFeeTotal = item.clientFeeTotal;
    this.RevenuePct = 0;
    this.Selected = false;
    this.OperationsMgrDailyCostOfficeOverrideCur = 0;
    this.PanelMgrRecruiterDailyCostOfficeOverrideCur = 0;

    if (this.FieldWorkRevenueTotal !== undefined && this.FieldWorkRevenueTotal !== 0) {
      this.RevenuePct = `${mathHelper.RoundToTwoDecimal(
        ((this.FieldWorkRevenueTotal - `${item.fieldWorkCostTotal}`) / this.FieldWorkRevenueTotal) * 100
      )} %`;
    }
  }
  static NavigationDesc = ['ServiceName', 'Name'];

  static nameOfTheItemDetailList() {
    return 'Pricing Detail';
  }
  static NameOfTheIdField() {
    return 'PricingDetailId';
  }
  static Currency() {
    return '';
  }
  static MoneyFieldsSecondary = [];
  static MoneyFields = [];
  static CurrencySecondary() {
    return '';
  }
  static DateFields = ['ModifiedOn'];
  static BoolFields = [];
  static FieldsToShowInListTable = [];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Select',
        orderById: '',
        data: VPricingDetailListTotalItem.getSelectedCellContent,
        tableminWidth: '80px',
      },
      { label: 'Id', orderById: 'Id', data: 'PricingDetailId', minWidth: 50 },
      {
        label: 'Name',
        orderById: 'Name',
        data: (item) => VPricingDetailListTotalItem.getPricingDetail(item),
        minWidth: 50,
      },
      {
        label: 'Is Selected?',
        orderById: 'IsCurrentVersion',
        data: VPricingDetailListTotalItem.GetSelectedStatus,
        minWidth: 50,
      },
      { label: 'Version', orderById: 'Version', data: 'Version', minWidth: 50 },
      {
        label: 'Currency',
        orderById: 'CurrencySymbol',
        data: (item) => `${item.CurrencySymbol} (${item.CurrencyCode})`,
        minWidth: 50,
      },
      {
        label: 'Revenue',
        orderById: 'Revenue',
        data: (item) => moneyHelper.toMoneyFormat(item.FieldWorkRevenueTotal, item.CurrencyCode),
        minWidth: 50,
      },
      {
        label: 'Cost',
        orderById: 'Cost',
        data: (item) => moneyHelper.toMoneyFormat(item.FieldWorkCostTotal, item.CurrencyCode),
        minWidth: 50,
      },
      { label: 'FW Revenue %', orderById: 'RevenuePct', data: 'RevenuePct', minWidth: 50 },
      { label: 'FW Fee', orderById: 'FWFee', data: 'ClientFeeBase', minWidth: 50 },
      { label: '# Evals', orderById: 'NumEvalsTotal', data: 'NumEvalsTotal', minWidth: 50 },
      { label: 'Status', orderById: 'Status', data: 'Status', minWidth: 50 },
      { label: 'Modified By', orderById: 'ModifiedByName', data: 'ModifiedByName', minWidth: 50 },
      { label: 'Modified On', orderById: 'ModifiedOn', data: 'ModifiedOn', minWidth: 50 },
    ];
  }

  static GetSelectedStatus(item) {
    return <div className='ponter'>{<FigmaBadge Active={item.IsCurrentVersion} />}</div>;
  }
  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            VPricingDetailListTotalItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnSelect(item, selected) {}

  static getPricingDetail(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.Name,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'sales_PricingDetailList/search',
      `PricingDetailId=${item.PricingDetailId}`,
      'Open up in a new tab'
    );
  }
}
